<mat-drawer-container class="example-container" autosize>
  <!-- <mat-drawer #drawer class="example-sidenav" mode="over" position="end" style="width: 280px">
    <mat-nav-list>
      <a mat-list-item (click)="downloadApp()">Picaggo App </a>
      <div style="position: relative; bottom: 0; width: 100%">
        <a mat-list-item routerLink="/home">Home</a>
        <a mat-list-item target="_blank" href="https://picaggo.com/EULA.html">User Agreement</a>
        <a mat-list-item target="_blank" href="https://picaggo.com/PrivacyPolicy.html">Privacy Policy</a>
        <a mat-list-item (click)="logout()">Logout
        </a>
      </div>
    </mat-nav-list>
  </mat-drawer> -->

  <div class="example-sidenav-content">

    <div class="table-holder mat-elevation-z8">

      <div class="title-holder">
        <button (click)="goBack()" class="btn back-btn">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="white" />
            <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
            <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
       
        <span class="title-text">Select Event</span>
      </div>

      <div class="example-header">
         <!-- <h1 class="list-title text-center">Select Event</h1> -->
        <mat-form-field appearance="outline">
          <mat-label>Search </mat-label>
          <input matInput (keyup)="applyFilter($event.currentTarget)">
          <mat-icon matSuffix>search</mat-icon>
          <!-- <mat-hint>Start typing first</mat-hint> -->
        </mat-form-field>
      </div>


      <table mat-table [dataSource]="dataSource" matSort style="border-bottom: 1px solid lightgrey;"
        class="source-sans-3-tablefont">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name </th>
          <td style="text-align: left !important;" mat-cell *matCellDef="let event"><a
              style="color: blue;text-decoration: underline;cursor: pointer;" (click)="wallSettings(event)"> {{
              event.name | titlecase }}</a>
            <img *ngIf="event.isScheduledEvent == false && event.start_time != null && event.end_time == null"
              src="/assets/live.gif">
            <span *ngIf="event.isScheduledEvent == true" style="padding: 6px;font-size: 10px;color:red;">Upcoming</span>
            <!-- <div><img src="/assets/live.gif"></div>
            <div class="pulse" *ngIf="event.start_time != null && event.end_time == null"></div> -->
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.start_time | date: 'EE, d MMM YYYY' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="send-notification">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Send Message</th>
          <td mat-cell *matCellDef="let event"> <button mat-raised-button color="primary" type="button"
              (click)="sendNotification(event.id)">Send Notification</button></td>
        </ng-container>
        <!-- <ng-container matColumnDef="add-branding">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Add Branding</th>
          <td mat-cell *matCellDef="let event"> <button class="picaggo-btn-primary " type="button"
              (click)="addBranding(event)">Add Branding</button></td>
        </ng-container> -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
    <!-- </ng-template> -->
    <ng-template [ngIf]="isLoading">
      <!-- <div class="fade-background" [class.show]="isLoading" name="fade-div"> -->
      <div class="overlay">
        <span class="loader"></span>
      </div>
      <!-- </div> -->
    </ng-template>
  </div>
</mat-drawer-container>